import { render } from "./BenefitMessagingCard.vue?vue&type=template&id=7fa3d700"
import script from "./BenefitMessagingCard.vue?vue&type=script&lang=js"
export * from "./BenefitMessagingCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__